<template>
    <div>

        <vue-headful title="Non-Compliant Inspection Items :: MeritEHS"/>

        <h4 class="py-3 mb-3">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active">
                    <i class="fa fa-exclamation-triangle"></i> Non-Compliant Inspection Items
                </li>
            </ol>
        </h4>

        <saved-filter-title :filterKey="'nonCompliantFilters'" />

        <div class="card">
            <div class="card-body">
                <non-compliant-list ref="reportNonCompliantList" :allowFilterSaving="true" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },

        methods: {

        },

        mounted(){
            //Focus on the SEarch Input
            this.$refs.reportNonCompliantList.$refs.nonCompliantTable.$refs.genericFilter.focus();
        },
    }
</script>
